import { Placeholder } from '@sitecore-jss/sitecore-jss-nextjs';
import { ComponentWithContextProps } from 'lib/component-props';
import { useMemo } from 'react';
import useHelpers from '../../hooks/helpers';

const Tiles = ({ rendering, sitecoreContext }: ComponentWithContextProps): JSX.Element => {
  const isExperienceEditor = sitecoreContext.pageEditing;
  const { backgroundClass, anchorId } = useHelpers(rendering);
  const showTilesHeading =
    (rendering?.placeholders?.['abrdn-tiles-heading']?.length &&
      (!!rendering?.placeholders?.['abrdn-tiles-heading']?.[0]?.fields?.title?.value ||
        !!rendering?.placeholders?.['abrdn-tiles-heading']?.[0]?.fields?.description?.value)) ||
    isExperienceEditor;

  const tilesHeadingUid = rendering?.placeholders?.['abrdn-tiles-heading']?.[0]?.uid || null;

  const containerSize = useMemo(() => {
    const size = rendering?.params?.size;
    if (size === 'default' || !size) {
      return 'col-6';
    }
    return size;
  }, [rendering]);

  return (
    <section
      id={anchorId}
      data-e2e-component-uid={rendering.uid}
      className={`${backgroundClass} tiles default-section-padding`}
    >
      <div className="container">
        {showTilesHeading && (
          <div className="row mb-4" data-testid={tilesHeadingUid}>
            <div className="col-12 col-lg-8">
              <Placeholder rendering={rendering} name="abrdn-tiles-heading" />
            </div>
          </div>
        )}
        <div className="row" data-testid="tiles">
          <Placeholder rendering={rendering} name="abrdn-tiles" containerSize={containerSize} />
        </div>
      </div>
    </section>
  );
};

export default Tiles;
